import { makeStyles } from '@material-ui/core/styles';
import React, { lazy, Suspense, useEffect } from 'react';
import Loader from 'react-loader-spinner';
import { connect } from 'react-redux';
import { Route, Switch, useHistory } from 'react-router-dom';
import { ToastsContainer, ToastsStore } from 'react-toasts';
import ContactUs from "../legal/ContactUs";
import check from "../rbac/check";
import Can from "../rbac/can";
import MenuDrawer from './MenuDrawer';
import NavBar from './NavBar';
import NotificationTask from '../task/NotificationTask';

const mapStateToProps = (state) => {
    return {
        searchData: state.reduceFilters.searchData,
        showLoader: state.reduceLoader.showLoader,
        timeout: state.reduceLoader.timeout,
        showContact: state.reduceLoader.showContact,
        hideMenu: state.reduceMenu.hideMenu
    }
}
export default connect(mapStateToProps)(AppRouter);

const Home = lazy(() => import("../home/Home"));
const SearchCases = lazy(() => import("../case/search/SearchCases"));
const DisplayCase = lazy(() => import("../case/display/DisplayCase"));
const ConsoleCases = lazy(() => import("../case/search/ConsoleCases"));
const ConsoleGuarantees = lazy(() => import("../case/search/ConsoleGuarantees"));
const ConsoleRepairs = lazy(() => import("../repair/search/ConsoleRepairs"));
const MyInformations = lazy(() => import("../collab/MyInformations"));
const ConsoleMessage = lazy(() => import("../message/ConsoleMessage"));
const SearchUser = lazy(() => import("../admin/SearchUser"));
const SearchCustomer = lazy(() => import("../admin/SearchCustomer"));
const User = lazy(() => import("../admin/User"));
const Customer = lazy(() => import("../admin/Customer"));
const LegalAgreements = lazy(() => import("../legal/LegalAgreements"));
const PageError = lazy(() => import("../error/PageError"));
const Page403 = lazy(() => import("../error/Page403"));
const Page404 = lazy(() => import("../error/Page404"));
const Reporting = lazy(() => import("../reporting/Reporting"));
const ConsoleTasks = lazy(() => import("../task/ConsoleTasks"));
const FAQ = lazy(() => import("../faq/FAQ"));

function AppRouter(props) {
    const classes = useStyles();
    const [open, setOpen] = React.useState(true);
    const history = useHistory();

    useEffect(() => {
        // Envoi des événements des pages visitées a GA
        // return history.listen(location => {
        //     ReactGA.set({ page: location.pathname });
        //     ReactGA.pageview(location.pathname);
        // });
    }, [history])

    useEffect(() => {
        setOpen(!props.hideMenu);
    }, [props.hideMenu]);

    const goIfCan = (component, action) => {
        if (check(action)) {
            return component;
        }
        return Page403;
    }

    return (
        <>
            <div className="appRout">
                <NavBar {...props} keycloak={props.keycloak} open={open} onDrawpen={setOpen} />
                <MenuDrawer {...props} open={open} onDrawpen={setOpen} />
                <main className="content">
                    <div className={classes.toolbar} />
                    <Suspense fallback={<Loader className="loader"
                        type="Oval" color="#00BFFF" height={100} width={100} timeout={10000}
                    />}>
                        <Switch>
                            <Route path="/" exact component={Home} />
                            <Route path="/search-cases" component={goIfCan(SearchCases, "search-cases:visit")} />
                            <Route path="/display-case" component={goIfCan(DisplayCase, "case:visit")} />
                            <Route path="/console-cases" component={goIfCan(ConsoleCases, "console-cases:visit")} />
                            <Route path="/console-guarantees" component={goIfCan(ConsoleGuarantees, "guarantee:visit")} />
                            <Route path="/console-repairs" component={goIfCan(ConsoleRepairs, "console-repairs:visit")} />
                            <Route path="/console-messages" component={goIfCan(ConsoleMessage, "console-messages:visit")} />
                            <Route path="/my-informations" component={MyInformations} />
                            <Route path="/search-user" component={goIfCan(SearchUser, "search-user:visit")} />
                            <Route path="/search-customer" component={goIfCan(SearchCustomer, "search-customer:visit")} />
                            <Route path="/create-user" component={goIfCan(User, "create-user:visit")} />
                            <Route path="/display-user" component={goIfCan(User, "create-user:visit")} />
                            <Route path="/display-customer" component={goIfCan(Customer, "create-user:visit")} />
                            <Route path="/create-customer" component={goIfCan(Customer, "create-customer:visit")} />
                            <Route path="/legal-agreements" component={LegalAgreements} />
                            <Route path="/console-reporting" component={goIfCan(Reporting, "reporting:visit")} />
                            <Route path="/console-tasks" component={ConsoleTasks} />
                            <Route path="/faq" component={FAQ} />
                            <Route path="/error" component={PageError} />
                            <Route component={Page404} />
                        </Switch>
                    </Suspense>
                </main>
                {props.showLoader &&
                    <Loader className="loader"
                        type="Oval" color="#00BFFF" height={100} width={100} timeout={props.timeout}
                    />
                }
                <Can
                    perform="console-tasks:visit"
                    yes={() => (
                        <NotificationTask />
                    )}
                />
            </div>
            <ContactUs open={props.showContact} />
            <ToastsContainer store={ToastsStore} />
        </>
    );
}

const useStyles = makeStyles(theme => ({
    toolbar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: theme.spacing(0, 1),
        ...theme.mixins.toolbar,
    },

}));

